export const fr = {
    rayban: {
        title: 'Découvrez Ray-Ban Meta dans une sélection de magasins',
        subtext: `Vous vous demandez où essayer et acheter les lunettes révolutionnaires Ray-Ban Meta AI Glasses ?`,
    },
    oakley: {
        title: 'Découvrez Oakley Meta dans une sélection de magasins',
        subtext:
            'Vous vous demandez où essayer et acheter les lunettes Oakley Meta IA ?',
    },
    nuance: {
        title: 'Découvrez Nuance dans une sélection de magasins',
        subtext:
            'Vous vous demandez où essayer et acheter les produits Nuance ?',
    },
    searchBelow: `Indiquez votre localisation et trouvez un magasin près de chez vous.`,
    searchPlaceholder: 'Recherche par code postal ou ville',
    fromYourLocation: 'de chez vous',
    mapView: 'Carte',
    listView: 'Liste',
    makeAppointment: 'Prenez un rendez-vous',
    viewDetails: 'Voir les détails',
    openingHours: `Heures d'ouverture`,
    specialOpeningHours: `Heures d'ouverture spéciales`,
    open: 'Ouvert',
    closed: 'Fermé',
    willOpen: 'Ouvrira',
    at: 'à',
    today: `aujourd'hui`,
    tomorrow: 'demain',
    showLess: 'Afficher moins de magasins',
    showAll: 'Afficher tous les magasins',
    privacy: 'Privacy',
    terms: 'Conditions générales',
    currentLocation: 'Emplacement actuel',
    useCurrentLocation: 'Utiliser mon emplacement actuel',
    errors: {
        locationNotFound: `Vos paramètres de localisation sont désactivés. Veuillez vérifier vos paramètres pour utiliser cette fonction.`,
        zipCodeNotFound: 'Nous ne trouvons pas ce code postal.',
    },
    seoRayban: {
        title: 'Trouvez Ray-Ban Meta chez un opticien Pearle près de chez vous | Pearle',
        descriptionContent:
            'Trouvez Ray-Ban Meta chez un opticien Pearle près de chez vous',
    },
    seoOakley: {
        title: 'Trouvez Oakley Meta chez un opticien Pearle près de chez vous | Pearle',
        descriptionContent:
            'Trouvez Oakley Meta chez un opticien Pearle près de chez vous',
    },
    seoNuance: {
        title: 'Trouvez Nuance chez un opticien Pearle près de chez vous | Pearle',
        descriptionContent:
            'Trouvez Nuance chez un opticien Pearle près de chez vous',
    },
};
